import Link from "next/link";
import Skeleton from "ui-components/Skeleton";

import config from "config";

import { useAuthProtect, checkForExpiry } from "../utils";
import { useGetUserDetails } from "../auth-state";

interface Props {
  children: React.ReactNode;
  stopExpiredUsers?: boolean;
}

const AuthLayout = ({ children, stopExpiredUsers = true }: Props) => {
  useAuthProtect();
  const userDetails = useGetUserDetails();

  if (!stopExpiredUsers) {
    return <>{children}</>;
  }

  if (!userDetails) {
    return <Skeleton>Loading...</Skeleton>;
  }

  if (config.ALLOWED_USERS) {
    if (!config.ALLOWED_USERS.includes(userDetails.email)) {
      return (
        <p className="text-center my-4 py-4">
          You aren't allowed to see this page!
        </p>
      );
    }
  }

  const { active, reason, expiryDate } = checkForExpiry(userDetails);
  if (!active) {
    if (reason === "subscription") {
      return (
        <>
          <h1 className="h2 text-center">Subscription Expired!</h1>
          {config.DEPLOY_ENV === "daisho-cloud" ? (
            <>
              {expiryDate && (
                <p className="text-center mt-4 text-xl">
                  Your subscription has EXPIRED on {expiryDate}
                  !!!
                </p>
              )}
              <p className="text-center mt-4 text-xl">
                <Link href="/profile/billing">
                  <a className="text-primary-main underline">Click here</a>
                </Link>{" "}
                to renew your subscription.
              </p>
            </>
          ) : (
            <p className="text-center mt-4 text-xl">
              Contact your administrator @ {config.ADMIN_CONTACT} for more
              details, and next steps.
            </p>
          )}
        </>
      );
    }
    if (reason === "license") {
      return (
        <>
          <h1 className="h2 text-center">License Expired!</h1>
          <p className="text-center mt-4">
            Your license has EXPIRED on {expiryDate}. Contact your administrator
            @ {config.ADMIN_CONTACT} for more details, and next steps.
          </p>
        </>
      );
    }
  }

  return <>{children}</>;
};

const Wrapper = ({ children, stopExpiredUsers }: Props) => {
  return (
    <div className="max-w-full mx-auto">
      <div className="pb-4 mb-8">
        <AuthLayout stopExpiredUsers={stopExpiredUsers}>{children}</AuthLayout>
      </div>
    </div>
  );
};

export default Wrapper;
